module.exports = __webpack_public_path__ + "static/CTA-Button-Fragen-sie-uns-001dde1e1255697dfd285cf78bdc9fbe.svg";